import { useState, useCallback } from "react";
import { useOptimizedAdminTable } from "@/hooks/useOptimizedAdminTable";
import { useToast } from "@/hooks/use-toast";
import RouteErrorBoundary from "@/components/error/RouteErrorBoundary";
import { UnifiedTableLayout } from "@/components/tables/unified";
import { getOrdersTableConfig } from "./ordersTableConfig";

export default function OrdersAdmin() {
  const { items, filteredItems, isLoading, fetchItems } = useOptimizedAdminTable('orders', 'order_number');
  const { toast } = useToast();

  // Memoized fetch function that returns cached data instantly
  const fetchOrdersData = useCallback(async () => {
    return filteredItems;
  }, [filteredItems]);

  const handleCSVImport = async (rows: any[]): Promise<void> => {
    try {
      toast({ 
        title: "Processing CSV import", 
        description: `Processing ${rows.length} rows...` 
      });
      
      // Mock import for now
      toast({ title: "CSV imported successfully", description: `Added ${rows.length} orders` });
    } catch (err: any) {
      toast({ 
        title: "Import failed", 
        description: err.message || "Unknown error occurred", 
        variant: "destructive" 
      });
      throw err;
    }
  };

  const handleExport = async () => {
    toast({ title: "CSV export coming soon!" });
  };

  const handleExportTemplate = async () => {
    toast({ title: "Template export coming soon!" });
  };

  const tableConfig = getOrdersTableConfig();

  return (
    <RouteErrorBoundary>
      <UnifiedTableLayout
        title={tableConfig.pageTitle}
        data={filteredItems}
        columns={tableConfig.columns}
        searchFields={tableConfig.searchFields}
        isLoading={isLoading}
        onImport={() => handleCSVImport([])}
        onExport={handleExport}
        onExportTemplate={handleExportTemplate}
        onRefresh={() => fetchItems()}
        rowActions={tableConfig.rowActions}
        onRowClick={tableConfig.onRowClick}
        addButtonText={tableConfig.addButtonText}
      />
    </RouteErrorBoundary>
  );
}